export default __webpack_public_path__ + "static/media/HalfImage.3b13c886.jpg";